import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import {Repository} from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { RmIndentQtyLimitDTO } from './dto/rm-indent-qty-limit.dto';
import { RmIndentQtyLimit } from './rm-indent-qty-limit.entity';
import { RmIndentQtyLimitAdapter } from './dto/rm-indent-qty-limit.adapter';
import { RmIndentQtyLimitResponse, AllRmIndentQtyLimitResponse } from '@gtpl/shared-models/raw-material-procurement';
import { RmIndentQtyLimitRequest } from './dto/rm-indent-qty-limit.request';
@Injectable()
export class RmIndentQtyLimitService {
    constructor(
        @InjectRepository(RmIndentQtyLimit) private rmIndentQtyLimitRepository: Repository<RmIndentQtyLimit>,
        private RmIndentQtyLimitAdapter: RmIndentQtyLimitAdapter,
      ) { }

      async createRmIndentQtyLimit(rmIndentQtyLimitDTO:RmIndentQtyLimitDTO, isUpdate: boolean): Promise<RmIndentQtyLimitResponse> {
       console.log('dto',rmIndentQtyLimitDTO)
        try {
        
        if (!isUpdate) {
            const rmIndentQtyLimitEntity = await this.getRmIndentQtyLimit(rmIndentQtyLimitDTO.date);
          if (rmIndentQtyLimitEntity) {
            throw new ErrorResponse(11104, 'Rm Indent Qty Limit already exists');
          }
        }
        else{
            const rmIndentQtyLimitEntity = await this.getRmIndentQtyLimit(rmIndentQtyLimitDTO.date);
            if (rmIndentQtyLimitEntity) {
                if(rmIndentQtyLimitEntity.rmIndentQtyLimitId!=rmIndentQtyLimitDTO.rmIndentQtyLimitId){
                    throw new ErrorResponse(11104, 'Rm Indent Qty Limit  already exists');
                }
            }
        }
        const convertedrmIndentQtyLimitEntity:RmIndentQtyLimit = this.RmIndentQtyLimitAdapter.convertDtoToEntity(rmIndentQtyLimitDTO,isUpdate);
        const savedrmIndentQtyLimitEntity: RmIndentQtyLimit = await this.rmIndentQtyLimitRepository.save(convertedrmIndentQtyLimitEntity);
        const savedrmIndentQtyLimitDTO: RmIndentQtyLimitDTO = this.RmIndentQtyLimitAdapter.convertEntityToDto(savedrmIndentQtyLimitEntity);
       
         if (savedrmIndentQtyLimitDTO) {
          const response = new RmIndentQtyLimitResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Rm Indent Qty Limit date Updated Successfully':'Rm Indent Qty Limit Created Successfully',savedrmIndentQtyLimitDTO);
          return response;
        } else {
          throw new ErrorResponse(11106,'Rm Indent Qty Limit saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all Rm Indent Qty Limit details  
     * @returns all the Rm Indent Qty Limit details .
     */
    // @LogActions({ isAsync: true })
    async getAllRmIndentQtyLimit(): Promise<AllRmIndentQtyLimitResponse> {  
        try {
            const rmIndentQtyLimitDTO: RmIndentQtyLimitDTO[] = [];
           
            const rmIndentQtyLimitEntities: RmIndentQtyLimit[] = await this.rmIndentQtyLimitRepository.find({
                order: { date: "ASC" },
            });
            
            if (rmIndentQtyLimitEntities.length>0) {
                rmIndentQtyLimitEntities.forEach(RmIndentQtyLimitEntity => {
                const convertedIndentQtyLimitDTO:RmIndentQtyLimitDTO = this.RmIndentQtyLimitAdapter.convertEntityToDto(RmIndentQtyLimitEntity);
                rmIndentQtyLimitDTO.push(convertedIndentQtyLimitDTO);
                });
                const response = new AllRmIndentQtyLimitResponse(true, 11208, "Rm Indent Qty Limit retrieved successfully", rmIndentQtyLimitDTO);
                return response;
            } else {
                //   console.log('yest')
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmIndentQtyLimit(date: Date): Promise<RmIndentQtyLimit> {
        
            const response = await this.rmIndentQtyLimitRepository.findOne({
            where: {date: date},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value    Rm indent Qty limit   
     * @param itemReq      Rm indent Qty limit as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    
    async activateOrDeactivateRmIndentQtyLimit(rmIndentQtyLimitReq: RmIndentQtyLimitRequest): Promise<RmIndentQtyLimitResponse> {
        try {
            console.log(rmIndentQtyLimitReq);
            const rmIndentQtyLimitExists = await this.getRmIndentQtyLimitById(rmIndentQtyLimitReq.rmIndentQtyLimitId);
            if (rmIndentQtyLimitExists) {
                if (rmIndentQtyLimitReq.versionFlag !== rmIndentQtyLimitExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current RmIndentQtyLimit information.Refresh and try again');
                } else {
                    
                        const rmIndentQtyLimitStatus =  await this.rmIndentQtyLimitRepository.update(
                            { rmIndentQtyLimitId: rmIndentQtyLimitReq.rmIndentQtyLimitId },
                            { isActive: rmIndentQtyLimitReq.isActive,updatedUser: rmIndentQtyLimitReq.updatedUser });
                       
                        if (rmIndentQtyLimitExists.isActive) {
                            if (rmIndentQtyLimitStatus.affected) {
                                const rmIndentQtyLimitResponse: RmIndentQtyLimitResponse = new RmIndentQtyLimitResponse(true, 10115, 'Rm IndentQtyLimit is de-activated successfully');
                                return rmIndentQtyLimitResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Rm Indent Qty Limit is already deactivated');
                            }
                        } else {
                            if (rmIndentQtyLimitStatus.affected) {
                                const rmIndentQtyLimitResponse: RmIndentQtyLimitResponse = new RmIndentQtyLimitResponse(true, 10114, 'Rm IndentQtyLimit is activated successfully');
                                return rmIndentQtyLimitResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Rm IndentQtyLimit is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmIndentQtyLimitById(rmIndentQtyLimitId: number): Promise<RmIndentQtyLimit> {
    
        const response = await this.rmIndentQtyLimitRepository.findOne({
        where: {rmIndentQtyLimitId: rmIndentQtyLimitId},
        });
        
        if (response) {
        return response;
        } else {
        return null;
        }
    }
}
